import React from "react";

function Logo() {
  return (
    <img
      src="/LogoLiberty.png"
      alt="Cloud Engineering Services Portal"
      className="h-8 w-auto object-contain sm:h-10 lg:h-12"
    />
  );
}

export default Logo;
